<template>
  <div id="member-center">
    <div class="jianbian-top"></div>
    <vice-title style="width: 75%; margin: 30px auto">
      <h3>{{ this.$t("lang.BetterMedicalCare.memberCenter") }}</h3>
    </vice-title>
    <div class="member-center">
      <div class="box">
        <h3 class="box-title">
          {{ this.$t("lang.BetterMedicalCare.benefitFourFamily") }}
        </h3>
        <div class="box-img">
          <div style="width: 40%">
            <img src="../../assets/images/box.png" alt="" />
          </div>
          <div style="width: 60%">
            <img src="../../assets/images/family.png" alt="" />
          </div>
        </div>
      </div>
      <div class="member-system">
        <h3>{{ this.$t("lang.BetterMedicalCare.memberSystem") }}</h3>
        <div class="three-line">
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div class="three-box">
          <div>
            <p>{{ this.$t("lang.BetterMedicalCare.name") }}</p>
            <p>{{ this.$t("lang.BetterMedicalCare.vipBasic") }}</p>
          </div>
          <div>
            <p>{{ this.$t("lang.BetterMedicalCare.name") }}</p>
            <p>{{ this.$t("lang.BetterMedicalCare.vipChinese") }}</p>
          </div>
          <div>
            <p>{{ this.$t("lang.BetterMedicalCare.name") }}</p>
            <p>{{ this.$t("lang.BetterMedicalCare.vipGlobal") }}</p>
          </div>
        </div>
      </div>
      <div class="notes">
        <h3 class="notes-explain">
          {{ this.$t("lang.BetterMedicalCare.instructions") }}
        </h3>
        <ul class="nodes-list">
          <li>{{ this.$t("lang.BetterMedicalCare.instructionsFirst") }}</li>
          <li>
            {{ this.$t("lang.BetterMedicalCare.instructionsSecond") }}
          </li>
          <li>
            {{ this.$t("lang.BetterMedicalCare.instructionsThird") }}
          </li>
          <li>
            {{ this.$t("lang.BetterMedicalCare.instructionsFourth") }}
          </li>
        </ul>
      </div>
    </div>
    <div class="jianbian-bottom"></div>
  </div>
</template>

<script>
import ViceTitle from "../ViceTitle";
export default {
  name: "MemberCenter",
  components: { ViceTitle },
  mounted() {
    console.log(this.$i18n.locale);
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#member-center {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  /*background: #e9e9e9;*/
  .jianbian-top {
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    height: 70px;
  }
  .jianbian-bottom {
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    height: 70px;
  }
  .member-center {
    width: 75%;
    margin: 0 auto;
    .box {
      .box-title {
        text-align: center;
        font-size: 24px;
        color: #868686;
      }
      .box-img {
        display: flex;
        align-items: center;
        div {
          width: 50%;
          img {
            width: 100%;
          }
        }
      }
      .box-content {
        color: #3490ec;
        h1 {
          margin-top: 240px;
          margin-bottom: 50px;
          font-size: 72px;
          text-align: right;
        }
        p {
          font-size: 40px;
        }
      }
    }
    .member-system {
      margin-top: 50px;
      text-align: center;
    }
    h3 {
      color: #515151;
      font-size: 22px;
    }
    .three-line {
      width: 730px;
      height: 10px;
      margin: 45px auto;
      /*background: #2a2a2a;*/
      display: flex;
      div {
        &:nth-child(1) {
          flex: 1;
          background: linear-gradient(
            270deg,
            rgba(211, 211, 211, 1) 0%,
            rgba(244, 244, 244, 1) 100%
          );
        }
        &:nth-child(2) {
          flex: 1;
          background: linear-gradient(
            270deg,
            rgba(251, 229, 194, 1) 0%,
            rgba(253, 244, 231, 1) 100%
          );
        }
        &:nth-child(3) {
          flex: 1;
          background: linear-gradient(
            255deg,
            rgba(176, 183, 228, 1) 0%,
            rgba(237, 238, 246, 1) 100%
          );
        }
      }
    }
    .three-box {
      width: 730px;
      height: 126px;
      margin: 0 auto;
      display: flex;
      div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-radius: 8px;
        p {
          color: #565656;
          margin-left: 22px;
          font-size: 20px;
          margin-bottom: 10px;
          text-align: left;
        }
        &:nth-child(1) {
          margin-left: 9px;
          margin-right: 18px;
          flex: 1;
          background: linear-gradient(
            270deg,
            rgba(211, 211, 211, 1) 0%,
            rgba(244, 244, 244, 1) 100%
          );
        }
        &:nth-child(2) {
          margin-right: 18px;
          flex: 1;
          background: linear-gradient(
            270deg,
            rgba(251, 229, 194, 1) 0%,
            rgba(253, 244, 231, 1) 100%
          );
        }
        &:nth-child(3) {
          flex: 1;
          margin-right: 9px;
          background: linear-gradient(
            255deg,
            rgba(176, 183, 228, 1) 0%,
            rgba(237, 238, 246, 1) 100%
          );
        }
      }
    }
    .notes {
      .notes-explain {
        font-size: 16px;
        color: #4f4f4f;
        margin: 80px 0 20px;
      }
      .nodes-list {
        line-height: 20px;
        font-size: 14px;
        color: #4f4f4f;
      }
    }
  }
}
</style>
